var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgLockIconGray = function SvgLockIconGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2371 6.69644H11.8343L11.8327 4.78156C11.831 2.69556 10.0519 0.998446 7.86504 1C5.6782 1.00156 3.89905 2.69867 3.90068 4.78467L3.90395 6.69956H3.76044C3.00866 6.70111 2.39876 7.28289 2.40039 8V13.7011C2.40039 14.4182 3.01193 15 3.7637 15L12.2403 14.9953C12.9921 14.9953 13.602 14.4136 13.6004 13.6964V7.99378C13.6004 7.27667 12.9889 6.69644 12.2371 6.69644ZM5.3651 6.69956L5.36184 4.78467C5.36184 3.46711 6.48379 2.39533 7.86504 2.39378C9.24628 2.39378 10.3699 3.46556 10.3699 4.78156L10.3731 6.69644L5.3651 6.69956Z",
    fill: "#817B6F"
  })));
};
var Memo = /*#__PURE__*/memo(SvgLockIconGray);
export default Memo;